import { createAction, props } from "@ngrx/store";

import { ApiKey, NewApiKey } from "./api-key.models";

export const getApiKeys = createAction("[API Key] Get API Keys");

export const getApiKeysSuccess = createAction(
  "[API Keys] Get API Keys Success",
  props<{ apiKeys: ApiKey[] }>()
);

export const apiKeysFailure = createAction(
  "[API Keys] API Keys Failure",
  props<{ error: string }>()
);

export const createApiKey = createAction("[API Key] Create API Key");

export const createApiKeySuccess = createAction(
  "[API Key] Create API Key Success",
  props<{ newApiKey: NewApiKey }>()
);

export const createApiKeyFailure = createAction(
  "[API Key] Create API Key Failure",
  props<{ error: string }>()
);

export const deleteApiKey = createAction(
  "[API Key] Delete API Key",
  props<{ id: string }>()
);

export const deleteApiKeySuccess = createAction(
  "[API Key] Delete API Key Success",
  props<{ id: string }>()
);

export const deleteApiKeyFailure = createAction(
  "[API Key] Delete API Key Failure",
  props<{ error: string }>()
);

export const toggleApiKey = createAction(
  "[API Key] Toggle API Key",
  props<{ id: string; isEnabled: boolean }>()
);

export const toggleApiKeySuccess = createAction(
  "[API Key] Toggle API Key Success",
  props<{ id: string; isEnabled: boolean }>()
);

export const clearCreatedApiKey = createAction("[API Key] Clear New API Key");
